import { Box, Button, ButtonGroup, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import DropdownSelect from 'components/dropdown-select/DropdownSelect'
import Textbox from 'components/textbox/Textbox'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { EditableHeading } from '../../../components/editable-heading/EditableHeading'
import FormGroupCard from '../../../components/form-components/FormGroupCard'
import FormQuestionCard from '../../../components/form-components/FormQuestionCard'
import { HeaderBlock } from '../../../components/header-block/HeaderBlock'
import PageContainer from '../../../components/page-container/PageContainer'
import CustomizedSnackbars from '../../../components/snackbar/Snackbar'
import SimpleTable from '../../../components/table/Table'
import ScrollableTabs from '../../../components/tabs/Tabs'
import { UUID } from '../../../helpers/uuid'
import { clearForm, createForm, updateCurrentForm } from '../../../state/actions/FormsActions'
import { FormChildrenType, FormType, FormValueType } from '../../../state/constants/FormConstants'
import { validateForm } from "./../FormsLibrary"
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'

const useStyles = makeStyles({
    contentWrapper: {
        margin: "8px 8px 8px 8px"
    },

    formTypeCard: {
        // maxHeight: "300px", /
        // overflow: "hidden",
    }
})

const Option = {
    id: "", // ?
    Name: "",
    SecondaryName: "",
    Type: FormValueType(),
    Value: "",
    Color: ""
}

const FormTypeTemplate = {
    refId: null,
    id: null,
    Order: null
}

const templates = {
    [FormChildrenType().QUESTION.key]: {
        base: {
            id: null,
            Tags: null, //[],
            Type: null, //null, //QuestionType.TEXT,
            Name: null, // ""
            Hint: null, // ""
            Description: null, //"",
            Validation: null, //[],
            IsMandatory: null, //MandatoryType.FALSE,
            InputType: null, //InputType.,
            Suffix: null,
            Prefix: null,
            Mask: null, //""
            ReferenceDataId: null, //"" // ?
            ConfigurationOptions: {}, // Ignore for now
            // Choice
            Options: null, //[], //Option
            MinChoices: null, //0,
            MaxChoices: null, //0,
            IsSticky: false
        },
        reduced: {
            Type: FormChildrenType().QUESTION.key,
            HideBackground: false,
            InfluencesCalculationsOf: null, // []
            InfluencesOutcomesOf: null, // []
            id: null
        }
    },
    [FormChildrenType().FORM_GROUP.key]: {
        base: {
            Dynamic: false,
            IsSticky: false,
            Name: null, //""
            FormGroupChildren: null, // []
            id: null
        },
        reduced: {
            Type: FormChildrenType().FORM_GROUP.key,
            HideBackground: false,
            id: null
        }
    }
}

function FormEditorV2(props) {

    const currentForm = useSelector(state => state.FormsReducer.currentForm)

    const dispatch = useDispatch()
    const classes = useStyles()
    const [t, i18n] = useTranslation()

    const [loading, setLoading] = useState(false)

    const [treeMap, setTreeMap] = useState({ rootNodes: [], allNodes: {} })
    const [newTreeData, setNewTreeData] = useState(true)
    const [disabled, setDisabled] = useState(false)
    const [errors, setErrors] = useState([])
    const [deleteItemModalOpen, setDeleteItemModalOpen] = useState(false)
    const [itemToDelete, setItemToDelete] = useState(null)
    const [formTypeSelection, setFormTypeSelection] = useState([])

    const [repeatFrequencyError, setRepeatFrequencyError] = useState({})

    useEffect(() => {
        if (currentForm.Pages.length == 0) {
            addRootFormGroup()
        }
        return () => {
            dispatch(clearForm(() => { }))
        }
    }, [])

    useEffect(() => {
        if (newTreeData) {
            setTreeMap(formTreeInitialisation())
            setNewTreeData(false)
        }
    }, [newTreeData])

    function handleValidation() {
        // Validate the form first...
        var errors = validateForm(JSON.stringify(currentForm))

        if (errors.length === 0) {
            return true;
        } else {
            setErrors(errors)
            return false;
        }
    }

    function handleCreate() {
        var isValid = handleValidation();

        setRepeatFrequencyError({})

        if (currentForm.FrequencyConfiguration != null) {
            if (currentForm.FrequencyConfiguration.StartingAnchorDate == null) {

                setRepeatFrequencyError({
                    DateError: t('form.no-date-error')
                })
                isValid = false
            }
            if (currentForm.FrequencyConfiguration.Frequency == null
                || currentForm.FrequencyConfiguration.Frequency == ""
                || !validateFormRepeatFrequency(currentForm.FrequencyConfiguration.Frequency)) {
                setRepeatFrequencyError({
                    NaNError: t('form.no-frequency-error')
                })
                isValid = false
            }
        }

        if (isValid) {
            dispatch(createForm(JSON.stringify(currentForm), () => {
                props.history.push("/forms");
            }));
        } else {
            setErrors([t('form.form-data-malformed')])
        }
    }

    function saveForm() {
        // Save form stuff via apis
        handleCreate()
    }

    function updateFormName(value) {
        const updatedData = Object.assign({}, currentForm)
        updatedData.Name = value
        dispatch(updateCurrentForm(updatedData, () => {

        }))
    }

    function questionComponent(props) {
        const question = props
        return (
            <FormQuestionCard disabled={disabled} question={question} setQuestion={setQuestion} handleDelete={(event) => {
                event.stopPropagation()
                setItemToDelete(question.id)
                setDeleteItemModalOpen(true)
            }} />
        )
    }

    function formGroupComponent(props) {
        const formGroup = props
        return (
            <FormGroupCard disabled={disabled} formGroup={formGroup} typeSwitch={typeSwitch} setFormGroup={setFormGroup} handleDelete={(event) => {
                event.stopPropagation()
                setItemToDelete(formGroup.id)
                setDeleteItemModalOpen(true)
            }} />
        )
    }

    function setFormGroup(formGroup, newChildren = null) {
        const newData = Object.assign({}, currentForm)
        var rerenderTree = false
        if (newChildren != null && newChildren.length > 0) {
            newChildren.forEach(type => {
                const newChild = Object.assign({}, templates[type].reduced)
                const id = UUID()
                newChild.id = id

                if (formGroup.FormGroupChildren == null) {
                    formGroup.FormGroupChildren = []
                }

                formGroup.FormGroupChildren.push(newChild)

                const newDataChild = Object.assign({}, templates[type].base)
                newDataChild.id = id

                newData[FormChildrenType()[type].formType][id] = newDataChild
            });
            rerenderTree = true
        }
        newData.FormGroups[formGroup.id] = formGroup
        dispatch(updateCurrentForm(newData, () => {

        }))

        if (rerenderTree) {
            setNewTreeData(true)
        }
    }

    function setQuestion(question, deleted = false) {
        const newData = Object.assign({}, currentForm)
        var rerenderTree = false
        if (deleted == true) { // For deleting of question
            rerenderTree = true
        }
        newData.Questions[question.id] = question
        dispatch(updateCurrentForm(newData, () => {

        }))
        if (rerenderTree) {
            setNewTreeData(true)
        }
    }

    function typeSwitch(item) {
        const node = treeMap.allNodes[item]

        if (node == null) {
            console.log("Bad data in Type Switch")
            return null
        }

        const nodeType = FormChildrenType()[node.Type].formType
        const value = currentForm[nodeType][node.id]

        if (value == null) {
            return null
        }



        switch (node.Type) {
            case "FORM_GROUP":
                return formGroupComponent(currentForm.FormGroups[node.id])
            case "QUESTION":
                return questionComponent(currentForm.Questions[node.id])
            default:
                return null
        }
    }

    function formTreeInitialisation() {
        const nodeMap = {
            rootNodes: [],
            allNodes: {}
        }

        if (currentForm == null || currentForm.FormGroups == null || currentForm.FormGroups.length == 0) {

            return nodeMap
        }

        const mapFormGroupNodeData = (formGroup) => {
            var formChildren = []
            if (formGroup.FormGroupChildren != null) {
                formChildren = formGroup.FormGroupChildren.map(child => child.id)
            }
            return {
                id: formGroup.id,
                Parents: [],
                Children: formChildren,
                Type: FormChildrenType().FORM_GROUP.key,
                Order: 0
            }
        }
        const mapQuestionNodeData = (question) => {
            return {
                id: question.id,
                Parents: [],
                Type: FormChildrenType().QUESTION.key,
                Order: 0
            }
        }

        var formList = Object.values(currentForm.FormGroups).map(item => mapFormGroupNodeData(item))
        var questionList = Object.values(currentForm.Questions).map(item => mapQuestionNodeData(item))

        formList.forEach((formGroup, index) => {
            nodeMap.allNodes[formGroup.id] = formGroup
        })

        questionList.forEach((question, index) => {
            nodeMap.allNodes[question.id] = question
        })

        formList.forEach(formGroup => {
            formGroup.Children.forEach((childId, index) => {
                const child = nodeMap.allNodes[childId]
                if (child == null) {
                    console.log(`Type not implemented for item ${childId}`)
                } else {
                    child.Order = index
                    nodeMap.allNodes[childId].Parents.push(formGroup.id)
                }
            })
        })

        nodeMap.rootNodes = formList.filter(item => item.Parents.length == 0).map(item => item.id)
        console.log("Recreating Tree", nodeMap)
        return nodeMap
    }

    function moveItemInHierarchy(oldParentId, newParentId, childId, updatedData) {
        const newParentType = FormChildrenType()[treeMap.allNodes[newParentId].Type].formType
        const newParent = updatedData[newParentType][newParentId]

        const oldParentType = FormChildrenType()[treeMap.allNodes[oldParentId].Type].formType
        const oldParent = updatedData[oldParentType][oldParentId]

        if (newParentType == FormChildrenType().FORM_GROUP.formType) {
            const childIndex = oldParent.FormGroupChildren.findIndex(item => item.id == childId)
            if (childIndex == -1) {
                console.log("error, failed to find child index")
            }

            const child = oldParent.FormGroupChildren.splice(childIndex, 1)

            if (child.length == 0) {
                console.log("error, failed to move child")
            }

            newParent.FormGroupChildren.push(child[0])
        }

        return updatedData
    }

    function addRootFormGroup() {
        const updatedData = Object.assign({}, currentForm)
        const newFormGroup = Object.assign({}, templates[FormChildrenType().FORM_GROUP.key].base)
        newFormGroup.id = UUID()
        newFormGroup.FormGroupChildren = []

        updatedData.FormGroups[newFormGroup.id] = newFormGroup

        updatedData.Pages.push({
            Name: newFormGroup.Name || "",
            StartsAt: newFormGroup.id
        })

        dispatch(updateCurrentForm(updatedData, () => {

        }))
        setNewTreeData(true)
    }

    function getNodeParents(nodeId) {
        const node = treeMap.allNodes[nodeId];
        if (node != null) {
            return node.Parents || []
        }

        return []
    }

    function deleteItem(itemId, deleteChildren = false) {
        const item = treeMap.allNodes[itemId]
        const type = FormChildrenType()[item.Type].formType

        var updatedData = Object.assign({}, currentForm)

        if (item.Parents.length == 0) {
            const index = updatedData.Pages.findIndex(child => child.StartsAt == itemId)
            updatedData.Pages.splice(index, 1)
        }
        if (deleteChildren) {
            // delete it all

        } else {
            if (item.Parents.length > 0) {
                const itemParent = item.Parents[0]
                if (item.Children != null && item.Children.length > 0) {
                    item.Children.forEach(child => {
                        updatedData = moveItemInHierarchy(item.id, itemParent, child, updatedData)
                    })
                }

                const parentType = FormChildrenType()[treeMap.allNodes[itemParent].Type].formType
                const parent = updatedData[parentType][itemParent]

                if (parent.FormGroupChildren != null && parent.FormGroupChildren.length > 0) {
                    const index = parent.FormGroupChildren.findIndex(child => child.id == itemId)
                    parent.FormGroupChildren.splice(index, 1)
                }

            } else {
                // no parents, just delete all
                if (item.Children != null && item.Children.length > 0) {
                    item.Children.forEach(childId => {
                        // find child
                        const childType = FormChildrenType()[treeMap.allNodes[childId].Type].formType
                        const child = updatedData[childType][childId]

                        if (childType == FormChildrenType().FORM_GROUP.formType) {
                            updatedData.Pages.push({
                                Name: child.Name || "",
                                StartsAt: child.id
                            })
                        } else {
                            // check for other parents
                            const parents = getNodeParents(childId).filter(childParent => childParent != itemId)
                            if (parents.length == 0) {
                                // delete child
                                delete updatedData[childType][childId]
                            }
                        }
                    })
                }
            }

            delete updatedData[type][itemId]


            dispatch(updateCurrentForm(updatedData, () => {

            }))
            setNewTreeData(true)
        }
    }

    function deleteItemModal() {
        return (
            <Dialog open={deleteItemModalOpen}>
                <DialogTitle >
                    {t('form.delete')}
                </DialogTitle>
                <DialogContent>
                    {t('common.remove-description')}
                    {/* Would you like to delete just this item, or all children as well? <br />
                    Children will be added as children to the current parent. */}
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        onClick={() => setDeleteItemModalOpen(false)}
                    >
                        {t('common.cancel')}
                    </Button>
                    {/* <Button
                        color="primary"
                        onClick={() => {
                            setDeleteItemModalOpen(false)
                            deleteItem(itemToDelete, true)
                        }}
                    >
                        Delete Children
                    </Button> */}
                    <Button
                        color="primary"
                        onClick={() => {
                            setDeleteItemModalOpen(false)
                            deleteItem(itemToDelete)
                        }}
                    >
                        {t('common.delete')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    function addFormType() {
        const updatedData = Object.assign({}, currentForm)
        const newFormType = Object.assign({}, FormTypeTemplate)

        newFormType.refId = UUID()
        if (updatedData.FormType == null) {
            updatedData.FormType = []
        }

        updatedData.FormType.push(newFormType)
        dispatch(updateCurrentForm(updatedData, () => {

        }))
    }

    function deleteFormType() {
        const updatedData = Object.assign({}, currentForm)
        const formTypesToDelete = formTypeSelection

        if (updatedData.FormType == null) {
            updatedData.FormType = []
        }

        updatedData.FormType = updatedData.FormType.filter(item => !formTypesToDelete.includes(item.refId))
        dispatch(updateCurrentForm(updatedData, () => {

        }))
        setFormTypeSelection([])
    }

    function handleAnchorDateChange(date) {
        const newData = Object.assign({}, currentForm)

        if (newData.FrequencyConfiguration == null) {
            newData.FrequencyConfiguration = {}
        }

        if (newData.FrequencyConfiguration.Frequency == null) {
            newData.FrequencyConfiguration.Frequency = 1
        }

        newData.FrequencyConfiguration.StartingAnchorDate = date

        dispatch(updateCurrentForm(newData, () => {

        }))
    }

    function handleRepeatFrequencyChange(value) {
        const newData = Object.assign({}, currentForm)

        if (newData.FrequencyConfiguration == null) {
            newData.FrequencyConfiguration = {}
        }

        var dataValue
        if (!validateFormRepeatFrequency(value)) {
            setRepeatFrequencyError({
                NaNError: t('form.repeat-frequency-error')
            })
            dataValue = value
        } else {
            setRepeatFrequencyError({})
            dataValue = parseInt(value).toString()
        }

        newData.FrequencyConfiguration.Frequency = dataValue

        if (newData.FrequencyConfiguration.StartingAnchorDate == null) {
            newData.FrequencyConfiguration.StartingAnchorDate = new Date()
        }

        dispatch(updateCurrentForm(newData, () => {

        }))
    }

    /**
     * Check that the given value is a int, and that it is between 1 and 12 for the form repeat frequency
     * @param {string} value: String value of an integer
     */
    function validateFormRepeatFrequency(value) {
        const intValue = parseInt(value)

        return (!isNaN(intValue) && intValue >= 1 && intValue <= 12)
    }

    function handleClearFrequencyConfiguration() {
        const newData = Object.assign({}, currentForm)

        newData.FrequencyConfiguration = null
        setRepeatFrequencyError({})

        dispatch(updateCurrentForm(newData, () => {

        }))
    }

    function renderPages() {
        return (
            <Grid container spacing={2}>

                {Object.values(treeMap.rootNodes).map(item => {

                    return (
                        <Grid item xs={12}>
                            {typeSwitch(item)}
                        </Grid>
                    )
                })}

            </Grid>
        )
    }

    function renderAdvanced() {
        const item = {
            type: "listView",
            label: t('form.form-type'),
            data: formTypeSelection,
            value: currentForm.FormType,
            dataId: "refId",
            headers: [
                {
                    id: "id",
                    clickable: false,
                    align: "left",
                    label: t('form.formtype-id'),
                    type: "dropDown",
                    typeData: Object.values(FormType()),
                    change: { identifier: "id" }
                },
                {
                    id: "Order",
                    clickable: false,
                    align: "left",
                    label: t('customer-flag.order'),
                    type: "textField",
                    change: { identifier: "Order" }
                }
            ],
            createCells: (headers) => {
                let cells = [];

                headers.forEach(header => {
                    let cell = {};

                    cell.id = header.id;

                    if (header.hasOwnProperty("change")) {
                        cell.onChange = (changedData, row) => {

                            let updatedData = Object.assign({}, currentForm);

                            if (updatedData.FormType == null) {
                                updatedData.FormType = []
                            }

                            const index = updatedData.FormType.findIndex(formType => formType.id === row.id);

                            updatedData.FormType[index][header.change.identifier] = changedData
                            dispatch(updateCurrentForm(updatedData, () => {

                            }))
                        }
                    }

                    cell.align = header.align;
                    cell.clickable = header.clickable;
                    cell.type = header.type;
                    cell.typeData = header.typeData

                    cells.push(cell);
                });

                return cells;
            },
            handleSelection: (newSelection) => {
                setFormTypeSelection(newSelection)
            }
        }

        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Card className={classes.formTypeCard}>
                        <CardHeader
                            title={t('form.form-frequency')}
                            action={
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={handleClearFrequencyConfiguration}
                                >
                                    {t('common.clear')}
                                </Button>
                            }
                        />
                        <CardContent>
                            <Typography variant="body2" color="textSecondary">
                                {t('form.repeat-frequency-description')}
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            margin="dense"
                                            // classes={{ root: styles.datePicker }}
                                            disableToolbar
                                            variant="inline"
                                            inputVariant="outlined"
                                            format="dd/MM/yyyy"
                                            label={t('form.anchor-date')}
                                            value={currentForm.FrequencyConfiguration?.StartingAnchorDate || null}
                                            fullWidth
                                            onChange={(date) => {
                                                handleAnchorDateChange(date)
                                            }}
                                            error={repeatFrequencyError.DateError != null}
                                            helperText={repeatFrequencyError.DateError}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        // classes={{ root: styles.textField }}
                                        label={t('form.repeat-frequency')}
                                        value={currentForm.FrequencyConfiguration?.Frequency || ""}
                                        fullWidth
                                        onChange={(event) => {
                                            handleRepeatFrequencyChange(event.target.value)
                                        }}
                                        variant="outlined"
                                        margin="dense"
                                        error={repeatFrequencyError.NaNError != null}
                                        helperText={repeatFrequencyError.NaNError}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12}>
                    <Card className={classes.formTypeCard}>
                        <CardHeader
                            title={t('form.form-types')}
                            action={
                                <ButtonGroup>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => deleteFormType()}
                                    >
                                        {t('common.delete')}
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="secondary"
                                        onClick={() => addFormType()}
                                    >
                                        {t('common.add')}
                                    </Button>
                                </ButtonGroup>
                            } />
                        <CardContent>
                            <SimpleTable
                                isEditing
                                isOrdered
                                isSticky
                                handleSelection={item.handleSelection}
                                isSelectable={true}
                                dataId={item.dataId}
                                headers={item.headers}
                                cells={item.createCells(item.headers)}
                                rows={item.value}
                                selected={item.data}
                                hidePagination
                            />
                        </CardContent>
                    </Card>

                </Grid>
            </Grid>
        )
    }

    function renderContent() {


        const tabs = [
            {
                id: "pages",
                name: t('common.pages'),
                render: () => renderPages()
            },
            {
                id: "advanced",
                name: t('common.advanced'),
                render: () => renderAdvanced()
            }
        ]

        return (
            <ScrollableTabs
                tabs={tabs.map(item => (
                    {
                        id: item.id,
                        name: item.name,
                        content: (
                            <Box className={classes.contentWrapper}>
                                {item.render()}
                            </Box>
                        )
                    }
                ))}
            />
        )
    }

    return (
        <Box>
            <HeaderBlock
                title={
                    <EditableHeading
                        value={currentForm.Name}
                        onChange={(event) => updateFormName(event.target.value)} />
                }
                right={
                    <ButtonGroup>
                        <Button
                            color="secondary"
                            onClick={() => addRootFormGroup()}
                            variant="outlined"
                        >
                            {t('form.add-page')}
                        </Button>
                        <Button
                            color="secondary"
                            disabled={currentForm.FormGroups != null ? Object.values(currentForm.FormGroups).length == 0 : true}
                            onClick={() => saveForm()}
                            variant="outlined"
                        >
                            {t('common.save')}
                        </Button>
                    </ButtonGroup>
                }
            />
            <CustomizedSnackbars
                handleClose={() => setErrors([])}
                open={errors.length > 0}
                variant="error"
                message={errors[0]}
            />
            {deleteItemModal()}
            <PageContainer>
                {renderContent()}
            </PageContainer>
        </Box>
    )
}

export default FormEditorV2
